// This types maps directly to API CheckoutMethod enum
export const COLLECTOR_CHECKOUT = 'COLLECTOR_CHECKOUT';
export const DIGITAL_SIGNING_ASSENTLY = 'DIGITAL_SIGNING_ASSENTLY'; // Legacy method
export const DIGITAL_SIGNING_SCRIVE = 'DIGITAL_SIGNING_SCRIVE';
